<template>
  <div id="price_setting">
    <dd-header></dd-header>
    <!-- 上部タブ -->
    <div class="container_main main_height">
      <!-- 左部サイドバー -->
      <nav class="sidebar_left">
        <div class="corp_list">
          <div>販売価格算出設定</div>
          <ul>
            <li>olis</li>
            <li>建具組合</li>
            <li>亀井</li>
          </ul>
        </div>
      </nav>
      <div class="main_content">
        <!-- <section class="factory_list">
          <table>
            <caption>工場一覧</caption>
            <thead>
              <tr>
                <th>生産工場</th>
                <th>工場分類</th>
                <th>郵便番号</th>
                <th>都道府県</th>
                <th>市町村</th>
                <th>その他住所/番地</th>
                <th>電話番号</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(factory, index) in factoryList" :key ="index" @mouseover="onMouseOverLine(index)" @mouseout="onMouseLeaveLine()">
                <td :ref="'factoryName' + index">
                  <span>{{factory.corpData.corpName}}</span>
                  <span class="editpen" v-if="isSelectedLine==index && !isEdit" @click="onPen($event, factory, 'corpName', index)"><img :src="getImage('component/common/icon/pen.svg')"></span>
                </td>
                <td :ref="'factoryType' + index">
                  <span>{{factory.corpData.corpSalesPriceCalcType}}</span>
                </td>
                <td :ref="'postcd' + index">
                  <span>{{factory.corpData.postcd}}</span>
                  <span class="editpen" v-if="isSelectedLine==index && !isEdit" @click="onPen($event, factory, 'postcd', index)"><img :src="getImage('component/common/icon/pen.svg')"></span>
                </td>
                <td :ref="'state' + index">
                  <span>{{factory.corpData.state}}</span>
                  <span class="editpen" v-if="isSelectedLine==index && !isEdit" @click="onPen($event, factory, 'state', index)"><img :src="getImage('component/common/icon/pen.svg')"></span>
                </td>
                <td :ref="'city' + index">
                  <span>{{factory.corpData.city}}</span>
                  <span class="editpen" v-if="isSelectedLine==index && !isEdit" @click="onPen($event, factory, 'city', index)"><img :src="getImage('component/common/icon/pen.svg')"></span>
                </td>
                <td :ref="'street' + index">
                  <span>{{factory.corpData.street}}</span>
                  <span class="editpen" v-if="isSelectedLine==index && !isEdit" @click="onPen($event, factory, 'street', index)"><img :src="getImage('component/common/icon/pen.svg')"></span>
                </td>
                <td :ref="'tel' + index">
                  <span>{{factory.corpData.tel}}</span>
                  <span class="editpen" v-if="isSelectedLine==index && !isEdit" @click="onPen($event, factory, 'tel', index)"><img :src="getImage('component/common/icon/pen.svg')"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </section> -->
        <section class="factory_list">
          <h2>販売価格算出設定</h2>
          <table v-for="(factory, index) in factoryProfitList" :key="index">
            <caption>{{factory.corpName}}</caption>
            <thead>
              <tr>
                <th>項目</th>
                <th v-for="(layer, index) in factory.layerList" :key="index">{{layer.layerName}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(category, index) in factory.profitCategoryList" :key="index"  @mouseover="onMouseOverLineProfit(index)" @mouseout="onMouseLeaveLineProfit()">
                <td>{{category.categoryName}}</td>
                <td v-for="(value, index2) in category.valueList" :key="index2" :ref="'category' + index + 'val' + index2">
                  <span>{{value.profit}}%</span>
                  <span class="editpen" v-if="isSelectedLineProfit==index && !isEdit" @click="onPenPer($event, factory, category, value, 'category' + index + 'val' + index2)"><img :src="getImage('component/common/icon/pen.svg')"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </div>
    <div id="inputmdl"></div>
    <dd-footer />
 </div>
</template>
<script>
// import Vue from 'vue'
import axios from 'axios'
import * as Api from '../utils/Api'
import * as App from '../utils/App'
// import * as AppEc from '../payment/utils/AppEc'
import {API_URL} from '../constants/App'
import Header from '../components/common/Header'
import Footer from '../components/common/Footer'
// import InputModal from '../components/common/InputModal'
export default {
  name: 'Output',
  components: {
    'dd-header': Header,
    'dd-footer': Footer
  },
  data () {
    return {
      factoryList: [],
      factoryInfoList: [],
      factoryProfitList: [],
      isSelectedLine: undefined,
      isSelectedLineProfit: undefined,
      isEdit: false,
      factoryOnList: []
    }
  },
  computed: {
  },
  methods: {
    fetchData: function () {
      axios.get(API_URL.FACTORY + '/'
      ).then(response => {
        this.factoryList = response.data.data
        console.dir(this.factoryList)
      }).catch(error => {
        Api.handleError(error)
      })
      axios.get(API_URL.FACTORY + '/factory-profit'
      ).then(response => {
        this.factoryProfitList = response.data.data
        console.dir(this.factoryProfitList)
      }).catch(error => {
        Api.handleError(error)
      })
    },
    olisData: function () {
      if (!this.factoryList) return []
      this.factoryList.filter(f => f.corpId === 1).map(f => f.factorySalesLayerId)
    },
    changeFactoryData: function () {
      axios.post(API_URL.FACTORY + '/setting'
      ).then(response => {
      }).catch(error => {
        Api.handleError(error)
      })
    },
    onMouseOverLine: function (index) {
      this.isSelectedLine = index
    },
    onMouseLeaveLine: function () {
      this.isSelectedLine = undefined
    },
    onMouseOverLineProfit: function (index) {
      this.isSelectedLineProfit = index
      console.log('sel line' + index)
    },
    onMouseLeaveLineProfit: function () {
      this.isSelectedLineProfit = undefined
      console.log('out line')
    },
    onPen: function (event, factory, refName, index) {
      this.isEdit = true
      let el = this.$refs[refName + index]
      console.dir(el)
      console.dir(event)

      let modalData = {
        onOk: (callback) => {
          console.dir(callback)
          el[0].firstChild.innerText = callback.text
          factory.corpData[refName] = callback.text
          this.isEdit = false
          this.updateFactoryData(factory)
        },
        onCancel: () => {
          this.isEdit = false
        },
        callbackParams: {},
        showSuccess: () => {},
        defaultText: el[0].innerText,
        top: el[0].offsetTop + el[0].offsetHeight,
        left: el[0].offsetLeft
      }
      App.showEditModal(modalData)
    },
    onPenPer: function (event, factory, category, val, refName) {
      this.isEdit = true
      console.log(refName)
      let el = this.$refs[refName]
      console.dir(el)
      console.dir(event)

      let modalData = {
        onOk: (callback) => {
          console.dir(callback)
          el[0].firstChild.innerText = callback.text + '%'
          val.profit = callback.text
          this.updateFactoryProfitData(factory, category, val)
        },
        onCancel: () => {
          this.isEdit = false
        },
        callbackParams: {},
        showSuccess: () => {},
        defaultText: el[0].innerText.replace('%', ''),
        top: el[0].offsetTop + el[0].offsetHeight,
        left: el[0].offsetLeft
      }
      App.showEditModal(modalData)
    },
    updateFactoryData: function (factory) {
      let payload = {
        corpId: factory.corpData.corpId,
        factoryName: factory.corpData.corpName,
        corpSalesPriceCalcType: factory.corpData.corpSalesPriceCalcType,
        postcd: factory.corpData.postcd,
        state: factory.corpData.state,
        city: factory.corpData.city,
        street: factory.corpData.street,
        tel: factory.corpData.tel
      }
      console.dir(payload)
      axios.post(API_URL.FACTORY + '/update-factory', payload
      ).then(response => {
        this.isEdit = false
      }).catch(error => {
        Api.handleError(error)
      })
    },
    updateFactoryProfitData: function (factory, category, val) {
      let payload = {
        corpId: factory.corpId,
        layerId: val.layerId,
        categoryId: category.categoryId,
        profitRate: val.profit
      }
      console.dir(payload)
      axios.post(API_URL.FACTORY + '/update-factory-profit', payload
      ).then(response => {
        this.isEdit = false
      }).catch(error => {
        Api.handleError(error)
      })
    },
    // onPen2: function (event, factory) {
    //   this.factoryOnList[factory.name] = true
    // },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  },
  mounted: function () {
    this.fetchData()
  },
  created: function () {
  }
}
</script>
<style src="../css/list/list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/pages/PriceSetting.vue